import { Typography } from "@material-tailwind/react";
import LogoSociete from '../images/Logo_Contact.svg';
import instalogo from '../images/Instragram.svg';
function Contact() {
  return (
	<div className="mt-24 py-6 w-5/6 ml-auto mr-auto md:w-3/6 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white from-0% to-gray-100 to-70% rounded-lg">
		<div className="md:flex md:columns-2">
			<div className="w-3/6 lg:w-2/6 mx-auto">
				<img alt="nature" className="mg:w-5/6 max-h-[30vh] my-auto mx-auto" src={LogoSociete}/>
			</div>
			<div className="flex flex-col gap-2 w-full lg:w-3/6 mt-3 text-left pl-5 md:ml">
				<Typography id="Claudia" variant="h4" color="blue-gray" className="mb-2">Claudia Pellegrin - EI</Typography>
				<Typography variant="h4" color="blue-gray"><a className="hover:text-black" href="mailto:tournee.accord@gmail.com">tournee.accord@gmail.com</a></Typography>
				<Typography variant="h5" color="blue-gray">06 06 48 44 09</Typography>
				<Typography variant="h5" color="blue-gray">SIRET : 93908761500018</Typography>
				<a href="https://www.instagram.com/la_tournee_d_accord?igsh=MTZyMWxwbzdlZXRuaQ==dre" target="_blank" className="flex items-center" rel="noopener noreferrer">
					<img src={instalogo} alt="Instagram" className="ml-[-10px] float-left w-16 h-16 hover:opacity-80 transition-opacity"/><Typography variant="h5" color="blue-gray">la_tournee_d_accord</Typography>
				</a>
			</div>
		</div>
	</div>
	
  );
}

export default Contact;
